export const CMS_ENTITY_TYPE = {
  PRODUCT_LIST: "PRODUCT_LIST",
  PRODUCT: "PRODUCT",
  WA_MSG_BANNER: "Whatsapp Message banner",
};

export const CAROUSEL_WALKTHROUGH = {
  WALKTHORUGH_SKIPPED: "Walkthrough Skipped",
  YOUTUBE_LINK_CLICKED: "Youtube Link Clicked",
  GET_STARTED: "Get Started",
};

export const SIGNUP_FLOW_EVENTS = {
  GET_STARTED: "Get Started",
  NUMBER_ENTERED: "Number Entered",
  NUMBER_VERIFIED: "Number Verified",
  NAME_ENTERED: "Name Entered",
  NAME_VERIFIED: "Name Submit",
  GENDER_SELECTED: "Gender Selected",
  GENDER_SUBMITTED: "Gender Submitted",
  REFERRAL_CODE_ENTERED: "Referral Code Entered",
  REFERRAL_CODE_SUBMITTED: "Referral Code Submitted",
  REFERRAL_CODE_RIGHT: "Referral Code Right",
  REFERRAL_CODE_WRONG: "Referral Code Wrong",
  SUCCESSFULL_REGISTRATION: "Successful Registration",
  SUCCESSFULL_LOGIN: "Successful Login",
  PINCODE_SERVICEABLE: "Pincode Serviceable",
  PINCODE_SUBMIT: "Pincode Submit",
  ADDRESS_SUBMIT: "Address Submit",
  SKIP_ADDRESS: "Address Skip",
  RESEND_OTP: "Resend OTP",
  CHANGE_NUMBER: "Change Number",
};

export const SIGNUP_FLOW_SOURCES = {
  TRUECALLER: "Truecaller",
  CALL_VERIFICATION: "Call Verification",
  MANUALLY: "Manually",
  MODAL: "Android Modal",
};

export const SIGNUP_FLOW_ADDRESS_SOURCES = {
  SIGNUP: "Signup",
  NUDGE: "Nudge",
  CHECKOUT: "Checkout",
};

export const DISCOVERY_FLOW_EVENTS = {
  PRODUCT_SEARCH_ICON: "Product Search Icon",
  PRODUCT_SEARCHED: "Products Searched",
  PRODUCT_LIST_VIEWED: "Product List Viewed",
  PRODUCT_VIEWED: "PRODUCT_VIEWED",
  PRODUCT_SEARCHED_FILTER_CLICKED: "Products Searched Filter Clicked",
};

export const ORDER_FLOW_EVENTS = {
  PRODUCT_CLICKED: "Product Clicked",
  PRODUCT_ADDED: "Product Added",
  PRODUCT_REMOVED: "Product Removed",
  PRODUCT_BUNDLED: "Product Bundle",
  CHECKOUT_STARTED: "Checkout Started",
  CHECKOUT_COMPLETED: "Order Completed",
  ORDER_COMPLETE: "Order Completed",
  ORDER_CANCELLED: "Order Cancelled",
  CL_PAYMENT_COMPLETE: "Cl payment complete",
  GO_TO_CX_APP_CLICK: "Go to CX App Clicked",

  CX_SELECTED: "Cx Selected",
  CX_CANCELLED: "Cx Cancelled",
  PLACE_ORDER_CLICKED: "Place Order Clicked",
  NEW_CX_ADDED: "New Cx Added",

  MY_ORDER_RETURN: "My Order Return",
  RETURN_REQUESTED: "Return Requested",
  REPLACEMENT_REQUESTED: "Replacement Requested",
  RETURN_SUBMITED: "Return Submited",
  REPLACEMENT_SUBMITED: "Replacement Submited",
  MY_ORDER_OTHER_HELP: "My Order Other Help",

  DELIVERY_RATING_STARTED: "Delivery Rating Started",
  DELIVERY_RATING_SUCCESS: "Delivery Rating Success",

  ADDRESS_CONFIRM_CLICK: "Address Confirmed",
  CHANGE_ADDRESS_CLICK: "Change Address triggered",
  DETAIL_CONFIRMATION_CLOSE_CLICK: "Detail Confirmed Closed",
  DETAIL_CONFIRMATION_OPENED: "Detail Confirmation Triggered",
};

export const SUPPORT_FLOW = {
  SUPPORT_TICKET_STARTED: "Support Ticket Started",
  SUPPORT_TICKET_CREATED: "Support Ticket Created",
  SUPPORT_TICKET_CANCELLED: "Support Ticket Cancelled",
  SUPPORT_TICKET_REOPENED: "Support Ticket Reopened",
  SUPPORT_TICKET_RATING: "Support Ticket Rating",
};

export const CUSTOMER_PAGE = {
  CX_PAGE_BANNER_CLICKED: "Cx Page Banner Clicked",
  CX_PAGE_NAME_CLICKED: "Cx Page Name Clicked",
  CX_PAGE_MESSAGE_CX_CLICKED: "Cx Page Message Cx Clicked",
  CMO_ENABLED: "CMO Enabled",
  CMO_DISABLED: "CMO Disabled",
  CX_PAGE_CX_ADD: "Page Cx Add",
  CX_PAGE_APP_SHARE: "Cx Page App Share",
  CX_DETAIL_MESSAGE: "Cx Detail Message",
  CX_DETAIL_CALL: "Cx Detail Call",
  CX_DETAIL_PLACE_ORDER: "Cx Detail Place Order",
  CX_DETAIL_SHARE_BILL: "Cx Detail Share Bill",
  CX_DETAIL_ALL_ORDERS: "Cx Detail All Orders",
  CX_DETAIL_SHARE_CART: "Cx Detail Share Cart",
  CX_DETAIL_WA_PREFILLED: "Cx Detail WA Prefilled",
  CX_DETAIL_DELETE: "Cx Detail Delete",
};

export const COUPON_FLOW_EVENTS = {
  APPLY_COUPON: "Apply Coupon",
  COUPON_SELECTED: "Coupon Selected",
  COUPON_APPLIED: "Coupon Applied",
};

export const SHARING_EVENTS = {
  CX_REFERRAL: "Cx Referral",
  GB_SHARE: "GB Share",
  PRODUCT_SHARE: "Product Share",
  LIST_SHARE: "List share",
  BANNER_SHARE: "Banner share",
  SHOP_SHARE: "Shop Share",
  CART_SHSARE: "Cart Share",
};

export const DPG_EVENTS = {
  DPG_LANDING: "DPG Landing",
  DPG_SHARE: "DPG Share",
  DPG_SAVE: "DPG Save",
  DPG_BANNER_TAP: "DPG Banner Tap",
};

export const OTHER_EVENTS = {
  LEADER_SHOP_SHARE: "Leader Shop Share",
  MESSAGE_LEADER: "Message Leader",
  CALL_LEADER: "Call Leader",
  CALL_SUPPORT: "Call Support",
  BANNER_CLICKED: "Banner Clicked",
  ADD_CUSTOMER_CLICK: "Add Customer Click",
  PHONEBOOK_SELECT: "Phonebook Select",
  ADD_CUSTOMER_SUCCESS: "Add Customer Success",
  PAISE_NIKALE: "Gullak - Paise Nikale",
  MONEY_CREDITED: "Gullak - Money Credited",
  MONEY_DEBITED: "Gullak - Money Debited",
  APP_LAUNCH_FROM_APK: "App launch from APK",
  APP_LAUNCHED_CUSTOM: "APP_LAUNCHED_CUSTOM",
  APP_LAUNCHED_CUSTOM_UTM: "App Launched Custom UTM",
  UPDATE_RECENT_SEARCH_DATA: "UPDATE_RECENT_SEARCH_DATA",
  LIST_THUMBNIL_CLICKED: "List Thumbail Clicked",
  Transaction_Failed: "Gullak - Transaction failed",
  WEB_ENTITY_CLICKED: "Web entity clicked",
};

export const SAVE_CM_NUMBER_EVENTS = {
  WA_BANNER_CLICKED: "WA Status Banner Click",
  WA_BANNER_CLICKED_SELECT: "WA Status Save Number",
  WA_STATUS_SUCCESS: "WA Status Success",
};

export const BOTTOM_TAB = "Bottom Tab";

export const BOTTOM_TABS_SOURCES = {
  HOME: "Home",
  TRAINING: "Training",
  ORDERS: "Orders",
  CUSTOMERS: "Customers",
  GULLAK: "Gullak",
};

export const LEADER_TRAINING = {
  INDEX_LANDING: "Training Landing",
  VIDEO_PLAYED: "Video Played",
  LISTING_LANDING: "Training List Landing",
};

export const PROFILE_EVENTS = {
  PROFILE_CLICK: "Profile Click",
  PROFILE_EDIT: "Profile Edit",
  PROFILE_SAVE: "Profile Save",
  PROFILE_GENDER_SAVE: "Profile gender save",
  PROFILE_AGE_SAVE: "Profile age save",
  PROFILE_OCCUPATION_SAVE: "Profile occupation save",
  PROFILE_AVAILABILITY_SAVE: "Profile availability save",
  PROFILE_INCOME_SAVE: "Profile income save",
  PROFILE_SOURCE_SAVE: "Profile source save",
  PROFILE_FAMILY_MEMBERS_SAVE: "Profile no_of_family_members save",
  PROFILE_GROCERY_SAVE: "Profile grocery_spending save",
  PROFILE_VEHICLE_SAVE: "Profile vehicle save",
  PROFILE_ALTERNATE_PHONE_SAVE: "Profile alternate_phone save",
};

export const DRAWER_EVENTS = {
  HAMBURGER_ITEM_CLICKED: "Hamburger Item Clicked",
  PAY_NOW_SUCCESS: "Pay Now Success",
};

export const PROFILE_EVENT_SOURCES = {
  PRIMARY: "primary",
  ADDRESS: "address",
  OTHERS: "others",
};

export const CAT_NAV_EVENTS = {
  PRIMARY_CAT_CLICKED: "Primary Cat Clicked",
  SUB_CAT_CLICKED: "Sub Cat Clicked",
  PTYPE_CAT_CLICKED: "PType Cat Clicked",
  LIST_VIEWED_CAT_NAV: "List Viewed Cat Nav",
};

export const CAT_NAV_SOURCES = {
  CAT_EX: "CAT_EX",
  CAT_IN: "CAT_IN",
};

export const DELIVERY_PAGE_EVENTS = {
  DELIVERY_SUCCESS: "Delivery Success Marked",
  DELIVERY_FAIL: "Delivery Failure Marked",
};

export const MY_ORDERS_EVENTS = {
  ORDER_CARD_CLICK: "My Order Tile Clicked",
  ORDER_SHARE: "My Order Share Order",
  ORDER_RATE: "My Order Rating",
  ORDER_CANCEL: "My Order Cancel Order",
};

export const THANK_YOU_ORDER_DETAILS = "Thank You Order Details";

export const CL_KYC = {
  KYC_LANDING: "KYC Landing",
  KYC_SUBMIT: "KYC Submit",
};

export const LGL = {
  LGL_LANDING: "LGL Landing",
  LGL_VIEW_DETAILS: "LGL View Details",
  LGL_MODULE_CLICKED: "LGL Module Clicked",
};

export const STORY_EVENTS = {
  STORY_CLICKED: "Story Clicked",
  STORY_VIEWED: "Story Viewed",
  STORY_SHARED: "Story Shared",
  STORY_SEE_DETAILS: "Story See Details",
  STORY_POLL_ANSWERED: "Story Poll Answered",
};

export const SELF_ORDER_BANNER = {
  PLACE_ORDER: "Self Order Place Order",
  SEE_VIDEO: "Self Order See Video",
};

export const SELF_ORDER_BANNER_ONLY = {
  PLACE_ORDER: "Self Order Place Order Banner",
  SEE_VIDEO: "Self Order See Video Banner",
};

export const AGENT_CONTACT = {
  CALL: "Call Agent",
};
export const WidgetContactShop = {
  WIDGET_CONTACT_ADD_CTA: "Widget Contact Add CTA",
  WIDGET_SHOP_SHARE_CTA: "Widget Shop Share CTA",
};

export const CCFP_EVENTS = {
  CCFP_CCFP_CLICKED: "CCFP clicked",
  CHECK_BOX_MARKED: "Check box marked",
  CCFP_REGISTERED_SUCCESSFULLY: "CCFP Registered successfully",
  CCFP_PAISE_NIKALE_CLICKED: "CCFP paise nikale clicked",
  CCFP_CREDITED: "CCFP credited",
  CCFP_DEBITED: "CCFP debited",
};

export const CL_PROFILE_EVENTS = {
  COMPLETE_PROFILE_CTA: "Profile puri kare",
  PROFILE_COMPLETE: "profile complete",
};

export const IJ_EVENTS = {
  IJ_KILL: "IJ Kill",

  IJ_SKIPPED: "IJ Skipped",
  IJ_COMPLETED: "IJ Completed",
  IJ_ANSWER_SUBMITTED: "IJ Answer Submitted",
};

export const CHANGE_NUMBER_EVENTS = {
  CHANGE_NUMBER_REQUEST: "Cl change number request",
  CHANGE_NUMBER_VERIFY: "Cl change number verify",
  CHANGE_NUMBER_SUCCESS: "Cl change number success",
};

export const HOMEPAGE_LOADED = "Homepage Loaded";

export const LOCATION_EVENTS = {
  LANDING: "Location Permission Landing",
  PERMISSION_GRANTED: "Location Permission Granted",
  PERMISSION_DENIED: "Location Permission Denied",
  SUBMITTED: "Location Submited",
  SEARCHED: "Location Searched",
  ANDROID_SETTINGS: "Android Settings Screen",
  SERVICEABLE_SIGNUP: "Serviceable signup",
  NOT_SERVICEABLE_SIGNUP: "Not Serviceable signup",
};

export const NON_SERVICEABLE_EVENTS = {
  LANDING: "Non Servicable Landing",
  CHANGE_LOCATION: "Non Servicable Change Location",
};

export const GULLAK_EVENTS = {
  PAISE_NIKALE: "Gullak  Paise Nikale",
  TRANSACTION_SUCCESSFUL: "Gullak transaction successful",
  TRANSACTION_FAILED: "Gullak transaction failed",
};

export const NOTIFICATION_EVENTS = {
  FPN_CLICKED: "FPN_CLICKED",
};
export const WALKTHROUGH = {
  STOPPED: "Walkthrough Stopped",
  COMPLETED: "Walkthrough Completed",
  NEXT: "Walkthrough Next",
};

export const ORDER_TRACKING = {
  SHIPMENTS_ICON_CLICK: "SHIPMENTS_ICON_CLICK",
  DB_CALL_BUTTON_CLICKED: "DB_CALL_BUTTON_CLICKED",
  REASON_RTO: "reason RTO",
  REPORT_RTO_CLICKED: "Report RTO clicked",
  REPORT_RTO_YES: "Report RTO  yes",
  REPORT_RTO_NO: "Report RTO  No",
  DELIVERY_MARKED_BY_CL: "Delivery mark click by CL",
  RTO_DELIVERY_CALL: "RTO delivery call",
  DELIVERY_CARD_CALL: "Delivery Card Call Btn",
};

export const PRIVILEGE_SCREEN = {
  ALREADY_CX: "Already Cx",
};

export const DISCARDED_SCREEN = {
  CL_DISCARDED: "CL discarded",
};

export const CMO_CX_SCREEN = {
  SCREEN_LANDED: "CMO_CX screen Landed",
  CALL_BTN_CLICKED: "CMO_CX call button clicked",
  DIST_CLICK: "CMO_CX Distance Button Click",
  ACCEPT: "CMO_CX Accept",
  REJECT: "CMO_CX Reject",
  WIDGET_CLICKED: "CMO_CX request Widget click",
};

// Self deactivation

export const SELF_DEACTIVATION = {
  SELF_DEACTIVATION: "Self Deactivation",
  REACTIVATE_REQUEST: "Reactivate Request",
};
export const MY_SHOP = {
  TODAYS_CUSTOMER_CLICKED: "Today’s Customer Clicked",
  ORDERS_CLICKED: "Orders Clicked",
  UPDATE_CLICKED: "Update clicked",
  CTA_CLICKED: "CTA Clicked",
};

export const SHOP_PERFORMANCE_EVENTS = {
  SHOP_PERFORMANCE_VIEWED: "Shop Performace Viewed",
  INFO_VIEWED: "Info Viewed",
  SHOP_PERFORMANCE_TAB_VIEWED: "Shop Performance Tab Viewed",
  CX_PAGE_NAME_CLICKED: "CX Page Name Clicked",
  PTYPE_CAT_CLICKED: "PType Cat Clicked",
  PRODUCT_CLICKED: "Product Clicked",
  MONTH_SELECTED_CLICKED: "Month Selected Clicked",
  MONTH_SELECTED: "Month Selected",
  CX_NOT_CONNECT_SNACKBAR_ERROR: "CX Not connect Snackbar Error",
  RATING_VIEWED: "Rating Viewed",
  SHOP_PERFORMANCE_WIDGET_CLICK: "shop performance widget click",
  BOTTOM_SCREEN_VIEWED: "bottom screen viewed",
  RATING_PAGE_LANDED: "rating page landed",
  COMPLAINT_PAGE_LANDED: "complaint page landed",
};

export const CL_TASKS_EVENTS = {
  CL_TASKS_ENTRY_POINT: "Daily Task Banner Clicked",
  CL_TASK_CLICKED: "Task Clicked",
  CL_CTA_CLICKED: "CTA Clicked",
  CL_SUBTASK_COMPLETED: "Sub Task Completed",
  CX_CART_VIEWED: "CX cart viewed",
  WHATSAPP_IMAGE_SHARED: "WA image Shared",
  CX_FEEDBACK_INTIATED: "CX feedback Submit Initiated",
  CX_FEEDBACK_SUBMITTED: "CX feedback Submitted",
  CX_FEEDBACK_EDIT: "CX feedback edit initiated",
  TASK_COMPLETED: "Task Completed",
  TIP_SWIPED: "Tips swiped",
  PROMOTION_ITEM: "Promotion Item Shared",
  DELETED_CUSTOMER_CLICKED: "Deleted customer clicked",
  CX_PAGE_NAME_CLICKED: "Cx Page Name Clicked",
  CL_Continue_Button_Clicked: "Continue button clicked",
  PROMOTION_LINK_SHARED: "Promotion link shared",
  CL_TASKS_PROMOTION_BANNER: "Daily Task Promotion Banner Clicked",
};
// MyDeliveries

export const MY_DELIVERY_EVENTS = {
  TAB_CLICKED: "Header Tab Clicked",
  DB_CALLED: "DB called",
  CUSTOMER_CALLED: "Customer called",
  ORDERS_CLICKED: "Orders Clicked",
  VIEW_DETAILS_CLICKED: "View Details Clicked",
  CUSTOMER_TILE_CLICKED: "Customer tile clicked",
  ORDER_TILE_CLICKED: "Order Tile Clicked",
};

export const REFER_EARN = {
  REFER_REFER_NOW: "Refer Refer Now",
  REFER_CALL_REMINDER: "Refer Call Reminder",
};
export const EARLY_JOURNEY = {
  VIDEO_STARTED: "Video Started",
  VIDEO_PAUSED: "Video Paused",
  VIDEO_RESUMED: "Video Resumed",
  VIDEO_COMPLETED: "Video completed",
  VIDEO_DOBARA_DEKHE: "Video Dobara Dekhe",
  VIDEO_AAGE_BADHE: "Video Aage Badhe",
  VIDEO_ANSWER_SUBMITTED: "Video Answer Submitted",
  ANSWER_EXPLANATION_MODAL_CLICKED: "Answer Explaination Modal Clicked",
  CMS_1_LANDING: "CMS 1 landing",
  SHOP_NAME_POPUP: "Shop Name Popup",
  SHOP_NAME_SUBMITTED: "Shop Name Submitted",
  ADDRESS_FORM_CLICKED: "Address Form Clicked",
  ADDRESS_FORM_LANDING: "Address Form Landing",
  ADDRESS_CHANGE_CTA_CLICKED: "Address change CTA Clicked",
  ADDRESS_FORM_SUBMITTED: "Address Form Submitted",
  CMS_2_LANDING: "CMS 2 Landing",
  CONTINUE_BUTTON_CLICKED: "Continue button clicked",
};
export const FULL_ORDER_RETURN_RTO = {
  DECLARATION: "Full order return declaration",
  RETURN_REQUEST_REJECTED: "Full order return request rejected",
  RETURN_REQUEST_APPROVED: "Full order return request approved",
  REFUND_CREDITED_TO_CL: "Refund credited to CL",
  MARKING_CTA_CLICKED: "Marking CTA clicked",
};

// RRD

export const RRD_EVENTS = {
  MARKING_WIDGET_CLICKED: "Marking widget clicked",
  REFUND_TASKS_CLICKED: "Refund tasks clicked",
  MARKING_PAGE_CTA_CLICKED: "Marking page CTA clicked",
  MARKING_CARD_CLICKED: "Marking card clicked",
  VIEW_REFUND_IN_GULLAK: "View refund in gullak",
  CTA_CLICKED: "CTA clicked",
  OTP_WALKTHROUGH: "Marking with OTP walkthrough",
  OTP_SUBMIT: "Marking OTP submit",
  ALL_MARKING_DONE: "All markings done",
  COMISSION_MODAL_CLOSE: "Commission modal close",
  DELIVERY_OTP_MODAL_OPEN: "Delivery OTP Modal open",
  DELIVERY_OTP_PH1: "Delivery OTP Ph1",
  DELIVERY_OTP_MODAL_PH1: "Delivery OTP Modal Ph1",
  DELIVERY_OTP_MODAL_PH2: "Delivery OTP Modal Ph2",
};

export const PERFORMANCE_MATRICES = {
  SEE_EXPECTATION: "Performance matrices see expectation",
  REPORT_LANDED: "Performance matrices report page landed ",
  VIDEO_PLAYED: "performance metric played video",
};

export const commissionEventsProps = {
  header_cross: "header cross",
  primary_btn: "primary btn",
};

export const eventActionMapping = {
  confirmPickup: "Pickup",
  confirmCancelPickup: "Cancel Pickup",
  unmarkPickup: "Unmark Pickup",
  confirmDelivery: "delivery",
  cancelDelivery: "Full order return",
  confirmCancelReturnReq: "Cancel Full order return",
  unmarkDelivery: "Unmark Delivery",
  confirmRefund: "Refund",
};

export const configEvents = {
  IDFA_NOT_FOUND: "IDFA Not Found",
  AD_TRACKING_LIMITED: "Ad Tracking Limited",
};

export const WALLET_BLOCKED_EVENTS = {
  IDFA_MODAL_CLOSE: "IDFA closed modal clicked",
  IDFA_MODAL_RAISE_TICKET: "IDFA modal raise ticket clicked",
};

export const DELIVERY_COMMUNICATION_EVENTS = {
  DEL_COMM_MODAL_SHOW: "Delivery Comm Modal Show",
  DEL_COMM_BTN_YES: "Delivery Comm Button Yes",
  DEL_COMM_BTN_NO: "Delivery Comm Button No",
  DEL_COMM_BTN_CLOSE: "Comm Button Close",
};

export const LOGOUT_INFO_EVENTS = {
  LOGOUT_PAGE_BUTTON: "Click on logout page button",
  LOGOUT_PAGE_LANDED: "logout page landed",
  VIEWED_LOGIN_MODULE: "Viewed new login module",
  SUBMIT_LOGOUT_BUTTON: "Submit logout button",
};

export const SEARCH_EVENTS = {
  SEARCH_CLICKED: "Search_click",
  SEARCH_CROSS_CLICKED: "Search_cross_click",
};

export const DELIVERY_CODE_EVENTS = {
  VIEW_CODE: "Delivery Code View",
};

export const CP_DB_EVENTS = {
  CUSTOMERS_CALLED: "Customers called",
};

export const DELIVERY_PERFORMANCE = {
  DELIVERY_PERFORMANCE_MODAL_CLICKED: "Delivery Performance Modal Clicked",
};

export const MY_TASK_EVENTS = {
  CLEAR_FILTER: "Clear Filter",
  FILTER_APPLIED: "Filter Applied",
  OTP_REQUEST_BTN_PRESS: "OTP Request Btn Press",
  OTP_REQUEST_SUBMITTED: "OTP Request Submitted",
  OTP_REQUEST_SUBMIT_FAILED: "OTP Request Submit Failed",
};

export const MAP_VIEW_EVENTS = {
  MAP_BTN_PRESS: "Map Btn Press",
  MAP_TAG_PRESS: "Map Tag Press",
  MAP_CALL_BTN_PRESS: "Map Call Btn Press",
  MAP_WHATSAPP_BTN_PRESS: "Map WA Btn Press",
  MAP_ADDRESS_PRESS: "Map Address Press",
  MAP_MARKER_PRESS: "Map Marker Press",
};

export const FACE_CAPTURE_EVENTS = {
  FACE_CAPTURE_MODAL_OPEN: "Face Capture Modal Open",
  FACE_CAPTURE_MODAL_CLOSE: "Face Capture Modal Close",
  FACE_CAPTURE_MODAL_SUBMIT: "Face Capture Modal Submit",
  FACE_CAPTURE_MODAL_ERROR: "Face Capture Modal Error",
  FACE_CAPTURE_MODAL_BLOCKED: "Face Capture Modal Blocked",
};
